import classNames from 'classnames';
import React from 'react';
import styles from './ContentFrame.module.scss';

interface Props extends React.HTMLProps<HTMLDivElement> {
  /** Give the frame a title */
  title?: string;
  /** Apply spacing at end */
  spacing?: boolean;
  /** Apply standard padding inside container? */
  padding?: boolean;
  /** Apply standard shadow on container? */
  shadow?: boolean;

  /** Apply standard borders on container */
  borders?: boolean;
}

/** @deprecated - do not use. Stop. */
export const ContentFrame = (props: Props) => {
  const { children, title, className, spacing, shadow, borders = true, padding, ...rest } = props;
  const containerClass = classNames(styles.container, className, {
    [styles.spacing]: !!spacing,
    [styles.padding]: !!padding,
    [styles.shadow]: !!shadow,
    [styles.borders]: borders,
  });
  return (
    <React.Fragment>
      {!!title && <h3 className={styles.title}>{title}</h3>}
      <div {...rest} className={containerClass}>
        {children}
      </div>
    </React.Fragment>
  );
};
